import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Assessment as AssessmentIcon } from "@mui/icons-material";
import { GlobalBox } from "components/Box/GlobalBox";
import { TableInputs } from "components/CardTable/TableInputs";
import { useSearch } from "hooks/useSearch";
import {
  setCashDiscountCustomersReportFilters,
  getCashDiscountCustomersReportAction,
} from "redux/actions/Reports/reportCashDiscountCustomers/reportCashDiscountCustomersActions";
import { CASH_DISCOUNT_CUSTOMERS_REPORT_LOADINGS } from "redux/reducers/Reports/reportCashDiscountCustomers/types";

export const ReportCashDiscountCustomersView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const isLoadingComp = useSelector(({ search }) => search.isLoadingComp);
  const { station } = useSelector((state) => state.reportCashDiscountCustomers);

  const loading = isLoadingComp?.[CASH_DISCOUNT_CUSTOMERS_REPORT_LOADINGS.GET_REPORT] ?? false;

  const handleSubmit = (isPdf) => {
    if (!station?.id) {
      setSnackbar("Falta seleccionar planta.", 'warning');
      return;
    }
    dispatch(getCashDiscountCustomersReportAction({ station, isPdf }));
  };

  return (
    <GlobalBox title="Reporte de Clientes de Contado con Descuento" icon={<AssessmentIcon />}>
      <TableInputs
        reducer="reportCashDiscountCustomers"
        stations
        dispatchAction={setCashDiscountCustomersReportFilters}
        submitAction={() => handleSubmit(true)}
        submitButtonName="PDF"
        submitSecond={() => handleSubmit(false)}
        loading={loading}
      />
    </GlobalBox>
  );
};
